import findBrand from "../../components/findBrand";
import { brandDomains, fetchBrands } from "../../components/brand";
import {
  ON_FORM_DATA_CHANGE,
  LEVEL_UP,
  LEVEL_DOWN,
  SET_PASS,
  ON_ZIP_SEARCH_CHANGE,
  SET_LOADING,
  GET_ZIP_SITES,
  SUBMIT_DATA,
  GET_SITE_PROGRAM,
  GET_SITE_INFORMATION,
} from "../types";

const registrationReducer = (state, action) => {
  const { type, payload } = action;
  async function loadBrands() {
    await fetchBrands();
  }
  loadBrands();
  const brand_holston = brandDomains.brand_holston?.name;
  const brand_pbia = brandDomains.brand_pbia?.name;
  switch (type) {
    case "SET_LEARNING_CENTER":
      return {
        ...state,
        learningCenterCoordinates: payload.coordinates,
        formData: {
          ...state.formData,
          learningCenterName: payload.name,
          learningCenterCharter: payload.charter,
          learningCenterAddress: payload.address,
          brandPhoto: `${payload.charter.brandPhoto}`,
          brandIcon: payload.charter.brandIcon,
          principal: payload.principal,
          learningCenterId: payload.learningCenterId,
        },
      };
    case "GET_BRAND_DATA":
      return {
        ...state,
        Siteprogram: payload,
      };
    case GET_SITE_INFORMATION:
      let PrincipalObj = payload.people.find((p) => p.role == "Principal");
      return {
        ...state,
        siteInformation: payload,
        learningCenterCoordinates: payload.address.coordinates,
        formData: {
          ...state.formData,
          learningCenterName: payload.name,
          learningCenterCharter: payload.charter.name,
          learningCenterAddress: `${payload.address.address_1}, ${payload.address.city}, ${payload.address.state} ${payload.address.zip}`,
          charterWebsite: `${payload.charter.charterWebsite}`,
          charterContactnumber: `${payload.charter.charterContactnumber}`,
          brandIcon: `${payload.charter.brandIcon}`,
          principal: `${PrincipalObj ? PrincipalObj.person.name : "Unassigned"
            }`,
          site_id: `${payload._id}`,
        },
      };

    case GET_SITE_PROGRAM:
      return {
        ...state,
        Siteprogram: payload,
      };

    case LEVEL_UP:
      // Check if isMailingAddress is "yes"
      const isMailingAddressYes = state.formData.isMailingAddressTheSame["yes"];

      if (findBrand(brand_holston) === true || findBrand(brand_pbia)) {
        return {
          ...state,
          formLevel:
            state.formLevel === 17
              ? 17
              : state.formLevel === 4 && isMailingAddressYes
                ? 6 // Skip to form level 5
                : state.formLevel === 4 && isMailingAddressYes
                  ? 7 // Skip to form level 6 (or adjust as needed)
                  : state.formLevel + 1,
        };
      } else {
        return {
          ...state,
          formLevel:
            state.formLevel === 17
              ? 17
              : (state.formLevel === 2 || state.formLevel === 3) &&
                isMailingAddressYes
                ? 4 // Skip to form level 5
                : state.formLevel === 2 && !isMailingAddressYes
                  ? 3 // Skip to form level 6 (or adjust as needed)
                  : state.formLevel + 1,
        };
      }

    case LEVEL_DOWN:
      // Check if isMailingAddress is "yes"
      const isMailingAddressYes1 =
        state.formData.isMailingAddressTheSame["yes"];
      if (findBrand(brand_holston) === true || findBrand(brand_pbia)) {
        return {
          ...state,
          formLevel:
            state.formLevel === 0
              ? 0
              : state.formLevel === 6 && isMailingAddressYes1
                ? 4 // Skip to form level 4
                : state.formLevel === 6 && isMailingAddressYes1
                  ? 5 // Skip to form level 6 (or adjust as needed)
                  : state.formLevel - 1,
        };
      } else {
        return {
          ...state,
          formLevel:
            state.formLevel === 0
              ? 0
              : state.formLevel === 5 && isMailingAddressYes1
                ? 4 // Skip to form level 5
                : state.formLevel === 4 && isMailingAddressYes1
                  ? 2 // Skip to form level 6 (or adjust as needed)
                  : state.formLevel - 1,
        };
      }

    case "SUB_LEVEL_UP":
      let subChecksUp = [
        {
          id: 1,
          value:
            payload.name === "healthConditions" &&
            state.subFormLevels[payload.name] === 0 &&
            state.formData.knownHealthConditions["no"],
        },
        {
          id: 2,
          value:
            payload.name === "healthConditions" &&
            state.subFormLevels[payload.name] === 3 &&
            state.formData.knownEyeCondition["no"],
        },
        {
          id: 3,
          value:
            payload.name === "parentInformation" &&
            state.subFormLevels[payload.name] === 0 &&
            state.formData.age < 18,
        },
        {
          id: 4,
          value:
            payload.name === "studentInformation" &&
            state.subFormLevels[payload.name] === 1 &&
            state.formData.registerForIntercession,
        },
        {
          id: 5,
          value:
            payload.name === "studentInformation" &&
            state.subFormLevels[payload.name] === 4 &&
            !state.formData.registerForIntercession,
        },
        {
          id: 6,
          value:
            payload.name === "studentInformation" &&
            state.subFormLevels[payload.name] === 5 &&
            state.formData.registerForIntercession,
        },
      ];
      let subToNextMainList = [
        {
          id: 1,
          value:
            payload.name === "parentInformation" &&
            state.formData.age >= 18 &&
            state.subFormLevels[payload.name] === 1 &&
            state.formData.permissionParentContact["no"],
        },
      ];
      let subToSkipMainLevel =
        payload.name === "physicalAddress" &&
        state.subFormLevels[payload.name] === 3 &&
        state.formData.isMailingAddressTheSame["yes"] &&
        !state.formData.registerForIntercession;
      let subToSkipToEnd =
        payload.name === "physicalAddress" &&
        state.subFormLevels[payload.name] === 3 &&
        state.formData.isMailingAddressTheSame["yes"] &&
        state.formData.registerForIntercession;
      let skipNextSubLevel = [
        {
          id: 1,
          value:
            payload.name === "studentInformation" &&
            state.formData.registerForIntercession &&
            state.subFormLevels[payload.name] === payload.cap,
        },
        {
          id: 2,
          value:
            payload.name === "parentInformation" &&
            state.formData.registerForIntercession &&
            (state.subFormLevels[payload.name] === payload.cap ||
              (state.formData.permissionParentContact["no"] &&
                state.subFormLevels[payload.name] === 1)),
        },
      ];
      let subIncreaseValue =
        subChecksUp.filter((e) => e.value === true).length > 0;
      let mainLevelIncreaseValue =
        subToNextMainList.filter((e) => e.value === true).length > 0;
      let skipNextSubCheck =
        skipNextSubLevel.filter((e) => e.value === true).length > 0;

      return {
        ...state,
        subFormLevels: {
          ...state.subFormLevels,
          [skipNextSubCheck
            ? payload.name === "studentInformation"
              ? "parentInformation"
              : "physicalAddress"
            : payload.name]: skipNextSubCheck
              ? state.formData.age >= 18 || payload.name === "parentInformation"
                ? 1
                : 2
              : state.subFormLevels[payload.name] === payload.cap ||
                mainLevelIncreaseValue
                ? state.subFormLevels[payload.name]
                : state.subFormLevels[payload.name] + (subIncreaseValue ? 2 : 1),
        },
        formLevel:
          state.subFormLevels[payload.name] === payload.cap
            ? state.formLevel === 16
              ? state.formLevel
              : state.formLevel +
              (subToSkipMainLevel ? 2 : subToSkipToEnd ? 13 : 1)
            : state.formLevel + (mainLevelIncreaseValue ? 1 : 0),
      };

    case "SUB_LEVEL_DOWN":
      let subChecksDown = [
        {
          id: 1,
          value:
            payload.name === "healthConditions" &&
            state.subFormLevels[payload.name] === 5 &&
            state.formData.knownHealthConditions["no"],
        },
        {
          id: 2,
          value:
            payload.name === "healthConditions" &&
            state.subFormLevels[payload.name] === 2 &&
            state.formData.knownEyeCondition["no"],
        },
        {
          id: 3,
          value:
            payload.name === "parentInformation" &&
            state.subFormLevels[payload.name] === 2 &&
            state.formData.age < 18,
        },
        {
          id: 4,
          value:
            payload.name === "studentInformation" &&
            state.subFormLevels[payload.name] === 3 &&
            state.formData.registerForIntercession,
        },
        {
          id: 5,
          value:
            payload.name === "studentInformation" &&
            state.subFormLevels[payload.name] === 6 &&
            !state.formData.registerForIntercession,
        },
        {
          id: 6,
          value:
            payload.name === "studentInformation" &&
            state.subFormLevels[payload.name] === 7 &&
            state.formData.registerForIntercession,
        },
      ];
      let subSkipNextMainSubLevel = [
        {
          id: 1,
          value:
            payload.name === "physicalAddress" &&
            state.formData.registerForIntercession &&
            state.subFormLevels[payload.name] === 1,
        },
        {
          id: 2,
          value:
            payload.name === "parentInformation" &&
            state.formData.registerForIntercession &&
            (state.subFormLevels[payload.name] === 1 ||
              (state.subFormLevels[payload.name] === 2 &&
                state.formData.age < 18)),
        },
      ];
      let skipMainLevelDown =
        state.formLevel === 5 && state.formData.isMailingAddressTheSame["yes"];
      let subDecreaseValue =
        subChecksDown.filter((e) => e.value === true).length > 0 ? 2 : 1;
      let checkSubSkipNextMainSubLevel =
        subSkipNextMainSubLevel.filter((e) => e.value === true).length > 0;

      return {
        ...state,
        subFormLevels: {
          ...state.subFormLevels,
          [checkSubSkipNextMainSubLevel
            ? payload.name === "physicalAddress"
              ? "parentInformation"
              : "studentInformation"
            : payload.name]: checkSubSkipNextMainSubLevel
              ? payload.name === "physicalAddress"
                ? state.subFormLevels["parentInformation"]
                : state.subFormLevels["studentInformation"]
              : state.subFormLevels[payload.name] === 0
                ? state.subFormLevels[payload.name]
                : state.subFormLevels[payload.name] - subDecreaseValue,
        },
        formLevel:
          state.subFormLevels[payload.name] === 0 ||
            checkSubSkipNextMainSubLevel
            ? state.formLevel - (skipMainLevelDown ? 2 : 1)
            : state.formLevel,
      };
    case "SELECT_ENROLLMENT_TYPE":
      return {
        ...state,
        formData: {
          ...state.formData,
          registerForIntercession: payload === "REGULAR" ? false : true,
        },
        subFormLevels: { ...state.subFormLevels, enrollmentType: 1 },
      };
    //check submit function is for stanza forms or other forms
    case SUBMIT_DATA:
      if (findBrand(brand_holston) === true || findBrand(brand_pbia)) {
        return {
          ...state,
          formLevel: 11,
        };
      } else {
        return {
          ...state,
          formLevel: 15,
        };
      }

    case ON_FORM_DATA_CHANGE:
      return {
        ...state,
        formData: {
          ...state.formData,
          [payload.name]: payload.value,
        },
      };
    case "GET_AGE":
      return {
        ...state,
        formData: { ...state.formData, age: payload },
      };

    case SET_PASS:
      return {
        ...state,
        pass: { ...state.pass, [payload.name]: payload.value },
      };

    case "SET_TO_ENGLISH":
      return {
        ...state,
        formData: {
          ...state.formData,
          ["firstLanguage"]: "English",
          ["homeLanguage"]: "English",
          ["languageSpokenByParentsToStudent"]: "English",
          ["languageSpokenByAdultsAtHome"]: "English",
        },
      };
    case ON_ZIP_SEARCH_CHANGE:
      return {
        ...state,
        zipSearch: {
          ...state.zipSearch,
          [payload.name]: payload.value,
        },
      };
    case SET_LOADING:
      return {
        ...state,
        loading: payload,
      };
    case GET_ZIP_SITES:
      let sortedSites = payload.data.sort((a, b) =>
        parseInt(a.distance) > parseInt(b.distance) ? 1 : -1
      );
      return {
        ...state,
        loading: false,
        zipCoordinates: payload.zipCoordinates,
        zipSites: sortedSites,
      };
    case "PRE_SELECTED_SITE":
      return {
        ...state,
        formLevel: 0,
        formData: { ...state.formData, learningCenter: payload },
        preSelected: true,
        charterBrandName: payload && payload.split(" - ")[1],
      };
    case "PRE_SELECTED_CHARTER":
      return {
        ...state,
        charterBrandName: payload,
      };
    default:
      return state;
  }
};

export default registrationReducer;
